export const statusData = [
  { label: 'Pending', value: 'pending' },
  { label: 'Completed', value: 'completed' },
  { label: 'Canceled', value: 'canceled' }
];